import {getSentFeedbackAtMs, isSimilarAlert} from './common.js';
import {CHANGE_TYPE_SENT_FEEDBACK} from '../constants';

export function buildGlobalChangedAlert(type, alert = null, data = {}) {
  // Changes (marking useful, removing) are bubbled to the root of the document. All mp-smart-hub-alerts in the
  // document listen for this event on the document root. When the event occurs for an (alertId, detailId)
  // matching the current mp-smart-hub-alert, it will update it's own state, and trigger a 'changedAlert' event
  // which parent elements (mp-alert-dropdown, mp-smart-hub-tooltip) can listen for to update their own state.
  // TODO(mack): Find a cleaner way to do this. The current way requires that all mp-smart-hub-alerts are in the
  // DOM, even when they are not visible (e.g. if the dropdown is not open). This is currently the case, but is
  // not guaranteed to be true forever.
  return new CustomEvent(`globalChangedAlert`, {
    detail: {
      type,
      alert,
      data,
    },
    bubbles: true,
    composed: true,
  });
}

export function buildGlobalChangeHandler(element, alert = null) {
  return (ev) => {
    if (alert && ev.detail.alert && !isSimilarAlert(ev.detail.alert, alert)) {
      return;
    }

    if (ev.detail.type === CHANGE_TYPE_SENT_FEEDBACK) {
      const sentFeedbackAtMs = getSentFeedbackAtMs(ev.detail.alert);
      element.setSentFeedbackAtMs(sentFeedbackAtMs);
    }

    element.dispatchEvent(
      new CustomEvent(`changedAlert`, {
        detail: Object.assign(ev.detail, {alert}),
      }),
    );
  };
}
